import Head from 'next/head'
import Homepage from '../containers/Home/Home'

export default function Home() {
  return (
    <div>
      <Head>
        <title>Welcome to My Proof</title>
      </Head>
      <Homepage />
    </div>
  )
}
